/*
 * Copyright (c) 2021.  Sanish Manandhar
 * All Rights Reserved
 */

export const CLEAN_HISTORY_PROPS = 'CLEAN_HISTORY_PROPS';

export const HISTORY_FETCH_REQUEST = 'HISTORY_FETCH_REQUEST';
export const HISTORY_FETCH_REQUEST_SUCCESS = 'HISTORY_FETCH_REQUEST_SUCCESS';
export const HISTORY_FETCH_REQUEST_FAILURE = 'HISTORY_FETCH_REQUEST_FAILURE';
